"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sha3_1 = __importDefault(require("./sha3"));

exports.default = function (name, _a) {
  if (name === void 0) {
    name = '';
  }

  var _b = _a === void 0 ? {} : _a,
      _c = _b.parent,
      parent = _c === void 0 ? null : _c,
      _d = _b.prefix,
      prefix = _d === void 0 ? true : _d;

  parent = parent || '0000000000000000000000000000000000000000000000000000000000000000';

  if (parent.match(/^0x/)) {
    parent = parent.substr(2);
  }

  var address = [parent].concat(name.split('.').reverse().filter(function (label) {
    return label;
  }).map(function (label) {
    return sha3_1.default(label, {
      hexPrefix: false
    });
  })).reduce(function (a, labelHash) {
    return sha3_1.default(a + labelHash, {
      hexPrefix: false,
      inputEnc: 'hex'
    });
  });
  return prefix ? '0x' + address : address;
};